import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { Modulo } from '../_models/modulo';
import { AuthService } from './auth.service';
import { BaseService } from './base.service';

@Injectable()
export class ModuloService extends BaseService {

    private endPoint = '/modulo';
    headers: Headers;
    options: RequestOptions;

    constructor(private http: Http,
        private auth: AuthService) {
        super();
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.options = new RequestOptions({ headers: this.headers });
    }

    obterModulosAutorizados(): Observable<Modulo[]> {
        return this.http.get(`${this.urlApi}${this.endPoint}/autorizados`, this.auth.obterAuthHeader()).pipe(
            map(this.extractData),
            catchError(this.handleError)
        );
    }

    obterModulosListar() {
        return this.http.get(`${this.urlApi}${this.endPoint}/listar`, this.auth.obterAuthHeader()).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    obterModulosPerfilAdminitradorTodos(): Observable<Modulo[]> {
        return this.http.get(`${this.urlApi}${this.endPoint}/listar_perfil_administrador`, this.auth.obterAuthHeader()).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    obterModulosPerfilAdministradorFiltro(filters: any) {
        return this.http.get(`${this.urlApi}${this.endPoint}/todos_administrador_filtro` + filters, this.auth.obterAuthHeader()).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    obterModulosUsuario(email: string): Observable<Modulo[]> {
        return this.http.get(`${this.urlApi}${this.endPoint}/por-usuario?email=` + email, this.auth.obterAuthHeader()).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    obterModuloPorId(id: string) {
        return this.http.get(`${this.urlApi}${this.endPoint}/por-id?id=` + id, this.auth.obterAuthHeader()).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }

    cadastrar(modulo: Modulo) {
        return this.http
            .post(this.urlApi + this.endPoint + '/cadastrar', modulo, this.auth.obterAuthHeader()).pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    atualizar(modulo: Modulo) {
        return this.http
            .post(this.urlApi + this.endPoint + '/atualizar', modulo, this.auth.obterAuthHeader()).pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    excluir(id: string) {
        return this.http.get(`${this.urlApi}${this.endPoint}/excluir?id=` + id, this.auth.obterAuthHeader()).pipe(
            map(this.extractData),
            catchError(this.handleError));
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/modulo.service.ts